import React from 'react';
import { Step, StepLabel, Stepper } from '@material-ui/core';

const steps = [
  { label: 'Solicitá tu certificado de alumno regular.' },
  { label: 'Elegi tu equipo al mejor precio' },
  { label: 'Completa el formulario y adjunta el certificado' },
  { label: 'Volve a clases con tu nuevo equipo!' },
];

export interface FormStepperProps {
  activeStep: number;
}

export const FormStepper = ({ activeStep }: FormStepperProps) => (
  <Stepper activeStep={activeStep} alternativeLabel>
    {steps.map(({ label }) => (
      <Step key={label}>
        <StepLabel>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
);
